<!-- Wrapper-->
<div id="wrapper">
  <!-- Left navigation bar -->
  <app-navigation></app-navigation>

  <!-- Main page wrapper -->
  <div id="page-wrapper" [ngClass]="{'menu-wrapper-size': this.menuView}">
    <!-- Top navigation -->
    <app-topnavbar></app-topnavbar>
    <app-chat-bot></app-chat-bot>
    <!-- Main view/routes wrapper-->
    <router-outlet></router-outlet>

  </div>
  <!-- End page wrapper-->
</div>
<!-- End wrapper-->
